import { Selector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { ProcessingCost } from '../types'

export const processingCostsSelector: Selector<ReduxState, Record<number, ProcessingCost>> = state =>
  state.processingCosts.processingCosts
export default processingCostsSelector
